<div class="card">
    <div class="card-header cp-list-header">
        <span class="cp-list-title">
            <i class="fa-solid" [ngClass]="isSupervisor ? 'fa-user-tie' : 'fa-shield-halved'"></i>
            {{ isSupervisor ? 'Teléfonos de supervisores' : 'Teléfonos de guardias' }}
            <span class="badge bg-primary ms-1">{{ collectionSize }}</span>
        </span>
        <span>
            <button class="btn btn-primary btn-sm" *ngIf="isSupervisor" (click)="openLink(linkPhone)"><i class="fa-solid fa-link me-1"></i>Vincular a perfil</button>
            <button class="btn btn-primary btn-sm" *ngIf="!isSupervisor" (click)="openModal(addDevice)"><i class="fa-solid fa-circle-plus me-1"></i>Nuevo</button>
        </span>
    </div>
    <div class="card-body">
        <div class="cp-filter-panel" [formGroup]="form">
            <div class="cp-toolbar">
                <div style="flex: 0 1 220px">
                    <label class="form-label">Tipo de teléfono</label>
                    <select class="form-select" (change)="changeKind()" formControlName="kind">
                        <option value="guard">Guardias</option>
                        <option value="supervisor">Supervisores</option>
                    </select>
                </div>
                <div style="flex: 1 1 240px" *ngIf="!isSupervisor">
                    <label class="form-label">Instalación</label>
                    <select class="form-select" (change)="search()" formControlName="facility_id">
                        <option [value]="0">Todas</option>
                        <option *ngFor="let item of facilityes" [value]="item?.id">{{ item?.name | uppercase }}</option>
                    </select>
                </div>
                <div class="text-muted small ms-auto" style="flex: 1 1 280px" *ngIf="isSupervisor">
                    Teléfonos vinculados a un perfil de supervisor. Un perfil puede tener varios teléfonos; quien inicie sesión en ellos actúa con ese perfil.
                </div>
            </div>
        </div>

        <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage" (pageChange)="search()"></ngb-pagination>
        <div class="table-responsive">
            <table class="table cp-table align-middle">
                <thead>
                    <tr *ngIf="isSupervisor">
                        <th>Teléfono</th><th>Perfil</th><th>Último usuario</th><th>Vinculado</th><th></th>
                    </tr>
                    <tr *ngIf="!isSupervisor">
                        <th>Teléfono</th><th>Instalación</th><th>Ubicación</th><th>Serie</th><th>Creación</th><th></th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="isSupervisor">
                        <tr *ngFor="let item of items">
                            <td>
                                <div class="fw-bold">{{ item?.name || 'Teléfono' }}</div>
                                <div class="small text-muted text-break">{{ item?.identification }}</div>
                            </td>
                            <td><span class="badge bg-primary">{{ item?.profile || '—' }}</span></td>
                            <td class="small">
                                {{ item?.last_user || '—' }}
                                <div class="text-muted" *ngIf="item?.last_used_at">{{ item?.last_used_at | date: 'dd-MM-yyyy HH:mm' }}</div>
                            </td>
                            <td class="small text-nowrap">{{ item?.created_at | date: 'dd-MM-yyyy' }}</td>
                            <td class="text-end text-nowrap">
                                <button type="button" class="btn btn-sm btn-outline-primary me-1" title="Cambiar de perfil" (click)="openLink(linkPhone, item)"><i class="fa fa-pencil"></i></button>
                                <button type="button" class="btn btn-sm btn-outline-danger" title="Retirar del perfil" (click)="openDelete(item.id,remove)"><i class="fa-solid fa-link-slash"></i></button>
                            </td>
                        </tr>
                    </ng-container>
                    <ng-container *ngIf="!isSupervisor">
                        <tr *ngFor="let item of items">
                            <td class="fw-bold">{{ item?.identification | uppercase }}</td>
                            <td class="small">
                                {{ item?.facility?.name | uppercase }}
                                <div class="text-muted" *ngIf="item?.facility?.location">{{ item?.facility?.location | uppercase }}</div>
                            </td>
                            <td><span class="badge bg-secondary">{{ (item?.place || 'Sin ubicación') | uppercase }}</span></td>
                            <td class="small">{{ item?.serie || '—' }}</td>
                            <td class="small text-nowrap">{{ item?.created_at | date: 'dd-MM-yyyy' }}</td>
                            <td class="text-end text-nowrap">
                                <button type="button" class="btn btn-sm btn-outline-primary me-1" title="Editar" (click)="openEdit(item.id,editDevice)"><i class="fa fa-pencil"></i></button>
                                <button type="button" class="btn btn-sm btn-outline-danger" title="Eliminar" (click)="openDelete(item.id,remove)"><i class="fa-solid fa-trash"></i></button>
                            </td>
                        </tr>
                    </ng-container>
                    <tr *ngIf="!items?.length">
                        <td colspan="6"><div class="cp-empty"><i class="fa-solid fa-mobile-screen"></i>No se encontraron teléfonos.</div></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage" (pageChange)="search()"></ngb-pagination>
    </div>
</div>

<ng-template #remove let-c="close" let-d="dismiss">
    <form (submit)="delete()" novalidate [formGroup]="form">
        <div class="modal-header">
            <h4 class="modal-title">Eliminar</h4>
            <button type="button" class="btn-close" aria-label="Cerrar" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body">
            <p *ngIf="!isSupervisor">¿Esta seguro que desea eliminar este registro?</p>
            <p *ngIf="isSupervisor">¿Retirar este teléfono del perfil? Quien inicie sesión en él dejará de ver las instalaciones y visitas del perfil.</p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">Cancelar</button>
            <button type="submit" ngbAutofocus class="btn btn-danger">Eliminar</button>
        </div>
    </form>
</ng-template>

<ng-template #addDevice let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-add-devices (success)="get()"></app-add-devices>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">Cancelar</button>
    </div>
</ng-template>
<ng-template #editDevice let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-edit-devices [dataId]="idSelected" (success)="get()"></app-edit-devices>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">Cancelar</button>
    </div>
</ng-template>
<ng-template #linkPhone let-d="dismiss">
    <div class="modal-header">
        <h5 class="modal-title"><i class="fa-solid fa-link me-2"></i>Vincular teléfono a un perfil</h5>
        <button type="button" class="btn-close" aria-label="Cerrar" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="alert alert-danger py-2" *ngIf="linkError">{{ linkError }}</div>
        <div class="mb-3">
            <label class="form-label small fw-bold">Teléfono conocido</label>
            <select class="form-select" [ngModel]="link.device_id" (ngModelChange)="pickKnown($event)">
                <option value="">Seleccione un teléfono desde el que ya se inició sesión…</option>
                <option *ngFor="let p of knownPhones" [value]="p.device_id">{{ p.name || 'Teléfono' }} · {{ p.last_user }}{{ p.profile ? ' (perfil ' + p.profile + ')' : '' }}</option>
            </select>
            <div class="form-text">También puede escribir el identificador a mano si el teléfono aún no ha iniciado sesión.</div>
        </div>
        <div class="row g-2 mb-3">
            <div class="col-md-7">
                <label class="form-label small fw-bold">Identificador del teléfono</label>
                <input class="form-control" maxlength="100" [(ngModel)]="link.device_id" />
            </div>
            <div class="col-md-5">
                <label class="form-label small fw-bold">Nombre <span class="text-muted fw-normal">(opcional)</span></label>
                <input class="form-control" maxlength="150" [(ngModel)]="link.device_name" />
            </div>
        </div>
        <div>
            <label class="form-label small fw-bold">Perfil</label>
            <select class="form-select" [(ngModel)]="link.profile_id">
                <option [ngValue]="0">Seleccione un perfil…</option>
                <option *ngFor="let p of profiles" [ngValue]="p.id">{{ p.name }}</option>
            </select>
            <div class="form-text">Un perfil puede estar en varios teléfonos. Cada supervisor que inicie sesión en ellos podrá realizar las visitas del perfil, varios a la vez.</div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="saveLink()">Guardar</button>
    </div>
</ng-template>
